import { ORDER_SERVICE_CORE_SERVICES_KINDS } from 'constants/_types/OrderServiceCoreServicesKinds';

export const CUMULATIVE_CORE_SERVICE_KINDS = [ORDER_SERVICE_CORE_SERVICES_KINDS.M_SUM, ORDER_SERVICE_CORE_SERVICES_KINDS.M_KUM];
